import {Generics, vertical, verticalPage} from "./generics.ts";
import {create} from "../../fjsc/src/f2.ts";
import {BagelInfo} from "../models/BagelInfo.ts";
import { bagels } from "../constants/bagels.ts";

export class Bagels {
    static page() {
        return Generics.pageFrame(
            true,
            verticalPage(
                create("h1")
                    .classes("flex-v")
                    .text("Bagels")
                    .build(),
                Bagels.bagels()
            )
        )
    }

    private static bagels() {
        return create("div")
            .classes("info-bagel-grid")
            .children(
                ...bagels.map(b => Bagels.bagel(b))
            ).build();
    }

    private static bagel(b: BagelInfo) {
        return create("div")
            .classes("info-bagel", "flex", "noflexwrap")
            .children(
                create("img")
                    .src(b.image)
                    .build(),
                vertical(
                    create("h2")
                        .text(b.name)
                        .build(),
                    create("span")
                        .classes("bagel-description")
                        .text(b.description)
                        .build(),
                    create("span")
                        .classes("bagel-ingredients")
                        .text(b.ingredients?.join(", "))
                        .build(),
                )
            ).build();
    }
}
